module.exports = "\"use strict\";"


//////////////////
// WEBPACK FOOTER
// ./~/raw-loader!./~/uglify-loader!./~/babel-loader/lib?{"presets":["react","es2015"],"plugins":["transform-class-properties","transform-object-assign"],"compact":false}!./client-side/Tree/js/tree_javascript.js
// module id = 143
// module chunks = 0